// Admin cost dashboard — spend across all APIs and all users.
// Admin-only (backend gates on require_admin). `raw` = provider cost;
// `charged` applies the billing markup.
import { api } from "./client";

export interface CostBreakdownRow {
  key: string;
  raw_usd: number;
  charged_usd: number;
  calls: number;
  tokens: number;
}

export interface CostUserRow {
  user_id: string;
  email: string;
  raw_usd: number;
  charged_usd: number;
  calls: number;
}

export interface CostDayPoint {
  date: string;
  raw_usd: number;
  charged_usd: number;
}

export interface CostCategoryRow {
  key: string;
  tokens: number;
}

export interface AdminCostsResponse {
  window_days: number;
  generated_at: string;
  total_raw_usd: number;
  total_charged_usd: number;
  markup: number;
  by_day: CostDayPoint[];
  by_user: CostUserRow[];
  by_source: CostBreakdownRow[];
  by_model: CostBreakdownRow[];
  by_category: CostCategoryRow[];
}

export function getCosts(days: number): Promise<AdminCostsResponse> {
  return api.get<AdminCostsResponse>("/admin/costs", { query: { days } });
}
